import { Fragment, useEffect, useState, useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSignIn, useSignOut } from "react-auth-kit";
import {
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";

import PaInfo from "./PaInfo";
import UserContext from "../../store/user-context";
import EmailSentModal from "../Modals/EmailSentModal";
import MunicipalityConfigurationModal from "../Modals/MunicipalityConfigurationModal";
import {
  Header,
  HeaderContent,
  HeaderBrand,
  HeaderRightZone,
  Nav,
  NavItem,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  Icon,
  Alert,
  Spinner,
} from "design-react-kit";

import logo from "../../assets/logo.svg";
import MunicipalityChangeModal from "../Modals/MunicipalityChangeModal";
import {
  isAIModuleAllowedHandler,
  isEfModuleAllowedHandler,
  isAuthModuleAllowedHandler,
  isStatisticModuleAllowedHandler,
} from "../../services/helpers";

const Navigation = () => {
  const [error, setError] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [emailSentModalOpen, setEmailSentModalOpen] = useState(false);
  const [municipalityConfigModalOpen, setMunicipalityConfigModalOpen] =
    useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [f24NotificationCount, setF24NotificationCount] = useState(0);
  const [readyFlowsCount, setReadyFlowsCount] = useState(0);
  const [stagedFlowsForTechAuthCount, setStagedFlowsForTechAuthCount] =
    useState(0);
  const [stagedFlowsForEconAuthCount, setStagedFlowsForEconAuthCount] =
    useState(0);
  const [stagedFlowsNotValidCount, setStagedFlowsNotValidCount] = useState(0);
  const [stagedFlowsNotCalculatedCount, setStagedFlowsNotCalculatedCount] =
    useState(0);

  const emailSentModalCloseHandler = () => {
    setEmailSentModalOpen(false);
  };

  const closeModalOnWidthChange = () => {
    if (window.innerWidth > 1330) {
      setMobileOpen(false);
      document
        .querySelector(".it-header-center-wrapper")
        .classList.remove("max-height");
    }
  };

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const userContext = useContext(UserContext);

  useEffect(() => {
    if (
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      setTimeout(() => {
        getNotificationWarnings();
        getStagedFlowsCounts();
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientName, userContext.selectedClientFiscalCode]);

  useEffect(() => {
    window.addEventListener("resize", closeModalOnWidthChange);
    if (
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      setTimeout(() => {
        isAIModuleAllowedHandler(
          userContext.selectedClientFiscalCode,
          signIn,
          signOut,
          navigate,
          userContext,
          setError
        );
        isEfModuleAllowedHandler(
          userContext.selectedClientFiscalCode,
          signIn,
          signOut,
          navigate,
          userContext,
          setError
        );
        isAuthModuleAllowedHandler(
          userContext.selectedClientFiscalCode,
          signIn,
          signOut,
          navigate,
          userContext,
          setError
        );
        isStatisticModuleAllowedHandler(
          userContext.selectedClientFiscalCode,
          signIn,
          signOut,
          navigate,
          userContext,
          setError
        );
      }, 100);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientName, userContext.selectedClientFiscalCode]);

  useEffect(() => {
    window.addEventListener("resize", closeModalOnWidthChange);
    if (
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null &&
      userContext.isAIModuleAllowed
    ) {
      setTimeout(() => {
        getNotificationWarnings();
      }, 100);
    }

    if (
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null &&
      userContext.isAuthModuleAllowed
    ) {
      setTimeout(() => {
        getStagedFlowsCounts();
      }, 100);
    }
    const interval = setInterval(() => {
      if (
        userContext.selectedClientName !== null &&
        userContext.selectedClientFiscalCode !== null &&
        userContext.isAIModuleAllowed
      ) {
        getNotificationWarnings();
      }

      if (
        userContext.selectedClientName !== null &&
        userContext.selectedClientFiscalCode !== null &&
        userContext.isAuthModuleAllowed
      ) {
        getStagedFlowsCounts();
      }
    }, process.env.REACT_APP_SCHEDULE_TIME);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", closeModalOnWidthChange);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientName, userContext.selectedClientFiscalCode]);

  const getNotificationWarnings = () => {
    sendApiRequest(
      "Common/GetNotificationWarnings",
      "GET",
      true,
      { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
      signIn,
      signOut,
      navigate,
      createQueryString,
      userContext
    ).then((response) => {
      if (response !== null) {
        if (response !== undefined && response.errors !== null) {
          setError(response.errors);
        } else {
          setNotificationCount(response.data.invalidNotificationsCount);
          setReadyFlowsCount(response.data.readyFlowsCount);
          setF24NotificationCount(
            response.data.invalidF24NotificationsCount ?? 0
          );
        }
      }
    });
  };

  const getStagedFlowsCounts = () => {
    sendApiRequest(
      "StagedFlows/GetStagedFlowsCounts",
      "GET",
      true,
      { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
      signIn,
      signOut,
      navigate,
      createQueryString,
      userContext
    ).then((response) => {
      if (response !== null) {
        if (response !== undefined && response.errors !== null) {
          setError(response.errors);
        } else {
          setStagedFlowsForTechAuthCount(
            response.data.stagedFlowsForTechAuthCount
          );
          setStagedFlowsForEconAuthCount(
            response.data.stagedFlowsForEconAuthCount
          );
          setStagedFlowsNotValidCount(response.data.stagedFlowsNotValidCount);
          setStagedFlowsNotCalculatedCount(
            response.data.stagedFlowsNotCalculatedCount
          );
        }
      }
    });
  };

  const addActiveNavigation = (e) => {
    if (e.target.parentNode.parentNode.classList.contains("dropdown-menu")) {
      e.target.parentNode.parentNode.previousSibling.firstChild.classList.add(
        "active"
      );
    } else if (
      e.target.parentNode.parentNode.classList.contains("dropdown-menu-2")
    ) {
      e.target.parentNode.parentNode.previousSibling.firstChild.classList.add(
        "active"
      );
    } else {
      e.target.classList.add("active");
    }
    setMobileOpen(false);
    document
      .querySelector(".it-header-center-wrapper")
      .classList.remove("max-height");

    let menuItem = document.querySelector(".menu-dropdown .dropdown-menu");

    if (menuItem !== null) {
      menuItem.classList.remove("show");
      menuItem.click();
    }

    let menuItem2 = document.querySelector(".menu-dropdown-2 .dropdown-menu");

    if (menuItem2 !== null) {
      menuItem2.classList.remove("show");
      menuItem2.click();
    }
  };

  const showNotificationCount = () => {
    if (notificationCount !== null && notificationCount !== undefined) {
      if (notificationCount === 0) {
        return (
          <span className="notification-count green">{notificationCount}</span>
        );
      } else {
        return (
          <span className="notification-count red">{notificationCount}</span>
        );
      }
    }
  };

  const showF24NotificationCount = () => {
    if (f24NotificationCount !== null && f24NotificationCount !== undefined) {
      if (f24NotificationCount === 0) {
        return (
          <span className="f24notification-count green mr-4">
            {f24NotificationCount}
          </span>
        );
      } else {
        return (
          <span className="f24notification-count red mr-4">
            {f24NotificationCount}
          </span>
        );
      }
    }
  };

  const showReadyFlowsCount = () => {
    if (readyFlowsCount !== null && readyFlowsCount !== undefined) {
      if (readyFlowsCount === 0) {
        return (
          <span className="readyFlows-count green">{readyFlowsCount}</span>
        );
      } else {
        return <span className="readyFlows-count red">{readyFlowsCount}</span>;
      }
    }
  };

  const mobileOpenToggleHandler = () => {
    setMobileOpen((currnentState) => {
      document
        .querySelector(".it-header-center-wrapper")
        .classList.toggle("max-height");
      return !currnentState;
    });
  };

  const logoutHandler = () => {
    sendApiRequest(
      "Authentication/Logout",
      "POST",
      true,
      null,
      null,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined && response.errors !== null) {
        setError(response.errors);
      }
    });
  };

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  const changePasswordHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    sendApiRequest(
      "Password/RequestChangePassword",
      "POST",
      true,
      { userId: userContext.userId },
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setMobileOpen(false);
          setIsLoading(false);
          document
            .querySelector(".it-header-center-wrapper")
            .classList.remove("max-height");
        } else {
          setEmailSentModalOpen(true);
          setMobileOpen(false);
          setIsLoading(false);
          document
            .querySelector(".it-header-center-wrapper")
            .classList.remove("max-height");
        }
      }
    });
  };

  const openDropdownHandler = (e) => {
    e.preventDefault();
    const target = e.target.closest(".menu-dropdown");
    const target2 = e.target.closest(".menu-dropdown-2");
    if (
      target !== null &&
      !target.classList.contains("show") &&
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      getNotificationWarnings();
    } else if (
      target2 !== null &&
      !target2.classList.contains("show") &&
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      getStagedFlowsCounts();
    }
  };

  const municipalityConfigModalCloseHandler = () => {
    setMunicipalityConfigModalOpen(false);
  };

  return (
    <Fragment>
      <Header
        type="center"
        style={{ backgroundColor: "#005A9A" }}
        className="w-100 position-fixed fixed-top align-items-start align-item-xl-start"
      >
        <HeaderContent className="d-flex flex-column flex-xl-row">
          <div className="menu-wrapper pt-3 mb-3">
            <div className="d-flex align-items-center align-items-xl-start justify-content-between justify-content-xl-start w-100">
              <div className="d-flex flex-column align-items-start flex-xl-row mt-1">
                <HeaderBrand className="border-right border-info pr-2 pl-0">
                  <img src={logo} alt="Logo" className="App-logo mb-3" />
                </HeaderBrand>
                <PaInfo />
              </div>
              <Icon
                icon="it-burger"
                fill="#ffffff"
                className="d-xl-none"
                onClick={mobileOpenToggleHandler}
                role="button"
              />
              <div className="d-none d-xl-flex">
                <Nav
                  navbar
                  secondary
                  className="d-flex flex-row align-items-start"
                >
                  {userContext.isStatisticModuleAllowed && (
                    <NavItem>
                      <NavLink
                        to="/statistics"
                        onClick={(e) => addActiveNavigation(e)}
                      >
                        Modulo statistico
                      </NavLink>
                    </NavItem>
                  )}
                  {userContext.userRoles !== null &&
                    (userContext.userRoles.includes("PAUser") ||
                      userContext.isAdmin) && (
                      <NavItem className="mb-4">
                        <NavLink to="/" onClick={(e) => addActiveNavigation(e)}>
                          Flussi
                        </NavLink>
                      </NavItem>
                    )}
                  {userContext.isEfModuleAllowed &&
                    userContext.userRoles !== null &&
                    (userContext.userRoles.includes("PAUser") ||
                      userContext.isAdmin) && (
                      <NavItem>
                        <NavLink
                          to="/externalFlows"
                          onClick={(e) => addActiveNavigation(e)}
                        >
                          Flussi esterni
                        </NavLink>
                      </NavItem>
                    )}
                  {userContext.isAIModuleAllowed &&
                    userContext.userRoles !== null &&
                    (userContext.userRoles.includes("PAUser") ||
                      userContext.isAdmin) && (
                      <NavItem>
                        <UncontrolledDropdown className="menu-dropdown">
                          <DropdownToggle>
                            <NavLink
                              to="/notificheAI"
                              onClick={(e) => openDropdownHandler(e)}
                            >
                              Notifiche AI
                            </NavLink>
                            {readyFlowsCount +
                              notificationCount +
                              f24NotificationCount >
                              0 && <span className="dot"></span>}
                            <Icon
                              icon="it-expand"
                              fill="#fff"
                              onClick={(e) => openDropdownHandler(e)}
                            />
                          </DropdownToggle>
                          <DropdownMenu>
                            <div className="d-flex align-items-center ml-3 mt-2">
                              <Icon icon="it-note" fill="#06c" />
                              <NavLink
                                id="flussi-pronti"
                                to="/notificheAI/flows"
                                className="d-flex align-items-center"
                                onClick={(e) => addActiveNavigation(e)}
                              >
                                Flussi pronti {showReadyFlowsCount()}
                              </NavLink>
                            </div>
                            <div className="d-flex align-items-center ml-3">
                              <Icon icon="it-info-circle" fill="#06c" />
                              <NavLink
                                id="da-verificare"
                                to="/notificheAI/verification"
                                className="d-flex align-items-center"
                                onClick={(e) => addActiveNavigation(e)}
                              >
                                Da verificare {showNotificationCount()}
                              </NavLink>
                            </div>
                            <div className="d-flex align-items-center ml-3">
                              <Icon icon="it-info-circle" fill="#06c" />
                              <NavLink
                                id="da-verificaref24"
                                to="/notificheAI/verificationf24"
                                className="d-flex align-items-center"
                                onClick={(e) => addActiveNavigation(e)}
                              >
                                Da verificare dati pagamenti{" "}
                                {showF24NotificationCount()}
                              </NavLink>
                            </div>
                            <div className="d-flex align-items-center ml-3">
                              <Icon icon="it-upload" fill="#06c" />
                              <NavLink
                                id="carica-documenti'"
                                to="/notificheAI/uploadFiles"
                                className="d-flex align-items-center"
                                onClick={(e) => addActiveNavigation(e)}
                              >
                                Carica documenti
                              </NavLink>
                            </div>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </NavItem>
                    )}
                  {userContext.isAuthModuleAllowed &&
                    userContext.userRoles !== null &&
                    (userContext.userRoles.includes("PASectorManager") ||
                      userContext.userRoles.includes("PAEconomicalManager") ||
                      userContext.isAdmin) && (
                      <NavItem>
                        <UncontrolledDropdown className="menu-dropdown-2">
                          <DropdownToggle>
                            <NavLink
                              to="/authModule"
                              onClick={(e) => openDropdownHandler(e)}
                            >
                              Modulo Autorizzativo
                            </NavLink>
                            {stagedFlowsForTechAuthCount +
                              stagedFlowsForEconAuthCount +
                              stagedFlowsNotValidCount +
                              stagedFlowsNotCalculatedCount >
                              0 && <span className="dot"></span>}
                            <Icon
                              icon="it-expand"
                              fill="#fff"
                              onClick={(e) => openDropdownHandler(e)}
                            />
                          </DropdownToggle>
                          <DropdownMenu>
                            {userContext.userRoles !== null &&
                              (userContext.userRoles.includes(
                                "PASectorManager"
                              ) ||
                                userContext.isAdmin) && (
                                <div className="d-flex align-items-center ml-2 pr-3 text-nowrap">
                                  <Icon icon="it-note" fill="#06c" />
                                  <NavLink
                                    id="auth-flows"
                                    to="/authModule/technicalFlows"
                                    className="d-flex align-items-center justify-content-between w-100"
                                    onClick={(e) => addActiveNavigation(e)}
                                  >
                                    Flussi disponibili (verifica tecnica)
                                    {
                                      <span className="stagedFlowsForTechAuthCount notification-count green">
                                        {stagedFlowsForTechAuthCount}
                                      </span>
                                    }
                                  </NavLink>
                                </div>
                              )}
                            {userContext.userRoles !== null &&
                              (userContext.userRoles.includes(
                                "PAEconomicalManager"
                              ) ||
                                userContext.isAdmin) && (
                                <div className="d-flex align-items-center ml-2 pr-3 text-nowrap">
                                  <Icon icon="it-note" fill="#06c" />
                                  <NavLink
                                    id="auth-flows"
                                    to="/authModule/economicalFlows"
                                    className="d-flex align-items-center justify-content-between w-100"
                                    onClick={(e) => addActiveNavigation(e)}
                                  >
                                    Flussi disponibili (verifica finanziaria)
                                    {
                                      <span className="stagedFlowsForEconAuthCount notification-count green">
                                        {stagedFlowsForEconAuthCount}
                                      </span>
                                    }
                                  </NavLink>
                                </div>
                              )}
                            {userContext.userRoles !== null &&
                              (userContext.userRoles.includes(
                                "PASectorManager"
                              ) ||
                                userContext.userRoles.includes(
                                  "PAEconomicalManager"
                                ) ||
                                userContext.isAdmin) && (
                                <div className="d-flex align-items-center ml-2 pr-3 text-nowrap">
                                  <Icon icon="it-info-circle" fill="#06c" />
                                  <NavLink
                                    id="auth-invalid-flows"
                                    to="/authModule/invalidFlows"
                                    className="d-flex align-items-center justify-content-between w-100"
                                    onClick={(e) => {
                                      addActiveNavigation(e);
                                    }}
                                  >
                                    Flussi non validi{" "}
                                    {
                                      <span className="stagedFlowsNotValidCount notification-count red">
                                        {stagedFlowsNotValidCount}
                                      </span>
                                    }
                                  </NavLink>
                                </div>
                              )}
                            {userContext.isAdmin && (
                              <div
                                className="d-flex align-items-center ml-2 pr-3 text-nowrap"
                                onClick={(e) => {
                                  addActiveNavigation(e);
                                }}
                              >
                                <Icon icon="it-info-circle" fill="#06c" />
                                <NavLink
                                  id="auth-invalid-flows"
                                  to="/authModule/flowsWithFailedCostCalculation"
                                  className="d-flex align-items-center justify-content-between w-100"
                                  onClick={(e) => {
                                    addActiveNavigation(e);
                                  }}
                                >
                                  Flussi (costo non calcolato)
                                  {
                                    <span className="stagedFlowsNotCalculatedCount notification-count red">
                                      {stagedFlowsNotCalculatedCount}
                                    </span>
                                  }
                                </NavLink>
                              </div>
                            )}
                            {userContext.userRoles !== null &&
                              (userContext.userRoles.includes(
                                "PASectorManager"
                              ) ||
                                userContext.userRoles.includes(
                                  "PAEconomicalManager"
                                ) ||
                                userContext.isAdmin) && (
                                <div className="d-flex align-items-center ml-2 pr-3 text-nowrap">
                                  <Icon icon="it-info-circle" fill="#06c" />
                                  <NavLink
                                    id="auth-invalid-flows"
                                    to="/authModule/flowsArchive"
                                    className="d-flex align-items-center justify-content-between w-100"
                                    onClick={(e) => addActiveNavigation(e)}
                                  >
                                    Flussi archiviati
                                  </NavLink>
                                </div>
                              )}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </NavItem>
                    )}
                  <hr className="separator" />
                  {userContext.userRoles !== null &&
                    (userContext.userRoles.includes("PAAdmin") ||
                      userContext.isAdmin) && (
                      <NavItem>
                        <NavLink
                          to="/users"
                          onClick={(e) => addActiveNavigation(e)}
                        >
                          Gestione utenze (Ente)
                        </NavLink>
                      </NavItem>
                    )}
                </Nav>
              </div>
            </div>
          </div>
          <HeaderRightZone className="d-none d-xl-flex">
            <div>
              <UncontrolledDropdown className="user-dropdown mt-3 mt-md-0">
                <DropdownToggle className="dropdownToggle">
                  <Icon icon="it-user" fill="#fff" className="user" />
                  <Icon icon="it-expand" fill="#fff" className="downArrow" />
                </DropdownToggle>
                <DropdownMenu>
                  <div className="d-flex align-items-center m-2">
                    <span className="user-email">
                      <Icon icon="it-user" />
                    </span>
                    <p className="m-0">{userContext.userEmail}</p>
                  </div>
                  <hr />
                  {isLoading && (
                    <p
                      style={{
                        height: "50px",
                        position: "absolute",
                        top: "35%",
                        left: "40%",
                        zIndex: "100",
                      }}
                    >
                      <Spinner double active />
                    </p>
                  )}
                  <div className="d-flex align-items-center ml-2">
                    <Icon icon="it-settings" fill="#06c" />
                    <Link
                      to={null}
                      id="change-password"
                      onClick={(e) => changePasswordHandler(e)}
                    >
                      Cambia Password
                    </Link>
                  </div>
                  {userContext.isAdmin && (
                    <div className="d-flex align-items-center ml-2">
                      <Icon icon="it-pa" fill="#06c" />
                      <Link
                        to={null}
                        id="change-client"
                        onClick={(e) => setModalOpen(true)}
                      >
                        Cambia Ente
                      </Link>
                    </div>
                  )}
                  {userContext.isAdmin && (
                    <div className="d-flex align-items-center ml-2">
                      <Icon icon="it-tool" fill="#06c" />
                      <Link
                        to={null}
                        id="change-client"
                        onClick={(e) => setMunicipalityConfigModalOpen(true)}
                      >
                        Configura Ente
                      </Link>
                    </div>
                  )}
                  {userContext.isAdmin && (
                    <div className="d-flex align-items-center ml-2 text-nowrap mr-2">
                      <Icon icon="it-tool" fill="#06c" />
                      <Link
                        to="/clientConfiguration"
                        id="configure-client"
                        onClick={(e) =>
                          document
                            .querySelector(".user-dropdown .dropdown-menu")
                            .classList.remove("show")
                        }
                      >
                        Configura Modulo AI
                      </Link>
                    </div>
                  )}
                  {userContext.isAdmin && (
                    <div className="d-flex align-items-center ml-2 text-nowrap mr-2">
                      <Icon icon="it-tool" fill="#06c" />
                      <Link
                        to="/externalFlowConfiguration"
                        id="configure-external-flows"
                        onClick={(e) =>
                          document
                            .querySelector(".user-dropdown .dropdown-menu")
                            .classList.remove("show")
                        }
                      >
                        Configura Flussi Esterni
                      </Link>
                    </div>
                  )}
                  {userContext.isAdmin && (
                    <div className="d-flex align-items-center ml-2 text-nowrap mr-2">
                      <Icon icon="it-tool" fill="#06c" />
                      <Link
                        to="/authModuleConfiguration"
                        id="configure-auth-module"
                        onClick={(e) =>
                          document
                            .querySelector(".user-dropdown .dropdown-menu")
                            .classList.remove("show")
                        }
                      >
                        Configura Modulo Autorizzativo
                      </Link>
                    </div>
                  )}
                  <div className="d-flex align-items-center ml-2">
                    <Icon icon="it-download" className="logout" fill="#06c" />
                    <Link id="logout" onClick={() => logoutHandler()}>
                      Logout
                    </Link>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </HeaderRightZone>
          {mobileOpen && (
            <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center mt-5 ">
              <Nav
                navbar
                secondary
                className="d-flex flex-column align-items-center"
              >
                {userContext.isStatisticModuleAllowed && (
                  <NavItem className="mb-4">
                    <NavLink
                      to="/statistics"
                      onClick={(e) => addActiveNavigation(e)}
                    >
                      Modulo statistico
                    </NavLink>
                  </NavItem>
                )}
                {userContext.userRoles !== null &&
                  (userContext.userRoles.includes("PAUser") ||
                    userContext.isAdmin) && (
                    <NavItem className="mb-4">
                      <NavLink to="/" onClick={(e) => addActiveNavigation(e)}>
                        Flussi
                      </NavLink>
                    </NavItem>
                  )}
                {userContext.isEfModuleAllowed &&
                  userContext.userRoles !== null &&
                  (userContext.userRoles.includes("PAUser") ||
                    userContext.isAdmin) && (
                    <NavItem className="mb-4">
                      <NavLink
                        to="/externalFlows"
                        onClick={(e) => addActiveNavigation(e)}
                      >
                        Flussi esterni
                      </NavLink>
                    </NavItem>
                  )}
                {userContext.isAIModuleAllowed &&
                  userContext.userRoles !== null &&
                  (userContext.userRoles.includes("PAUser") ||
                    userContext.isAdmin) && (
                    <NavItem>
                      <UncontrolledDropdown className="menu-mobile-dropdown">
                        <DropdownToggle>
                          <NavLink
                            to="/notificheAI"
                            onClick={(e) => openDropdownHandler(e)}
                          >
                            Notifiche AI
                          </NavLink>
                          {notificationCount !== null &&
                            notificationCount !== undefined &&
                            readyFlowsCount !== null &&
                            readyFlowsCount !== undefined &&
                            f24NotificationCount !== null &&
                            f24NotificationCount !== undefined &&
                            notificationCount +
                              readyFlowsCount +
                              f24NotificationCount >
                              0 && <span className="dot"></span>}
                          <Icon
                            icon="it-expand"
                            fill="#fff"
                            onClick={(e) => openDropdownHandler(e)}
                          />
                        </DropdownToggle>
                        <DropdownMenu>
                          <div className="d-flex align-items-center">
                            <Icon icon="it-note" fill="#06c" />
                            <NavLink
                              id="flussi-pronti"
                              to="/notificheAI/flows"
                              className="d-flex align-items-center justify-content-between w-100"
                              onClick={(e) => addActiveNavigation(e)}
                            >
                              Flussi pronti {showReadyFlowsCount()}
                            </NavLink>
                          </div>
                          <div className="d-flex align-items-center">
                            <Icon icon="it-info-circle" fill="#06c" />
                            <NavLink
                              id="da-verificare"
                              to="/notificheAI/verification"
                              className="d-flex align-items-center  justify-content-between w-100"
                              onClick={(e) => addActiveNavigation(e)}
                            >
                              Da verificare {showNotificationCount()}
                            </NavLink>
                          </div>
                          <div className="d-flex align-items-center ml-3">
                            <Icon icon="it-info-circle" fill="#06c" />
                            <NavLink
                              id="da-verificaref24"
                              to="/notificheAI/verificationf24"
                              className="d-flex align-items-center"
                              onClick={(e) => addActiveNavigation(e)}
                            >
                              Da verificare dati pagamenti{" "}
                              {showF24NotificationCount()}
                            </NavLink>
                          </div>
                          <div className="d-flex align-items-center">
                            <Icon icon="it-upload" fill="#06c" />
                            <NavLink
                              id="carica-documenti'"
                              to="/notificheAI/uploadFiles"
                              className="d-flex align-items-center"
                              onClick={(e) => addActiveNavigation(e)}
                            >
                              Carica documenti
                            </NavLink>
                          </div>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </NavItem>
                  )}
                {userContext.isAuthModuleAllowed &&
                  userContext.userRoles !== null &&
                  (userContext.userRoles.includes("PASectorManager") ||
                    userContext.userRoles.includes("PAEconomicalManager") ||
                    userContext.isAdmin) && (
                    <NavItem>
                      <UncontrolledDropdown className="menu-mobile-dropdown">
                        <DropdownToggle>
                          <NavLink
                            to="/authModule"
                            onClick={(e) => openDropdownHandler(e)}
                          >
                            Modulo Autorizzativo
                          </NavLink>
                          {stagedFlowsForTechAuthCount +
                            stagedFlowsForEconAuthCount +
                            stagedFlowsNotValidCount +
                            stagedFlowsNotCalculatedCount >
                            0 && <span className="dot"></span>}
                          <Icon
                            icon="it-expand"
                            fill="#fff"
                            onClick={(e) => openDropdownHandler(e)}
                          />
                        </DropdownToggle>
                        <DropdownMenu>
                          {userContext.userRoles !== null &&
                            (userContext.userRoles.includes(
                              "PASectorManager"
                            ) ||
                              userContext.isAdmin) && (
                              <div className="d-flex align-items-center ml-2 pr-3 text-nowrap">
                                <Icon icon="it-note" fill="#06c" />
                                <NavLink
                                  id="auth-flows"
                                  to="/authModule/technicalFlows"
                                  className="d-flex align-items-center justify-content-between w-100"
                                  onClick={(e) => addActiveNavigation(e)}
                                >
                                  Flussi disponibili (verifica tecnica)
                                  {
                                    <span className="stagedFlowsForTechAuthCount notification-count green">
                                      {stagedFlowsForTechAuthCount}
                                    </span>
                                  }
                                </NavLink>
                              </div>
                            )}
                          {userContext.userRoles !== null &&
                            (userContext.userRoles.includes(
                              "PAEconomicalManager"
                            ) ||
                              userContext.isAdmin) && (
                              <div className="d-flex align-items-center ml-2 pr-3 text-nowrap">
                                <Icon icon="it-note" fill="#06c" />
                                <NavLink
                                  id="auth-flows"
                                  to="/authModule/economicalFlows"
                                  className="d-flex align-items-center justify-content-between w-100"
                                  onClick={(e) => addActiveNavigation(e)}
                                >
                                  Flussi disponibili (verifica finanziaria)
                                  {
                                    <span className="stagedFlowsForEconAuthCount notification-count green">
                                      {stagedFlowsForEconAuthCount}
                                    </span>
                                  }
                                </NavLink>
                              </div>
                            )}
                          {userContext.userRoles !== null &&
                            (userContext.userRoles.includes(
                              "PASectorManager"
                            ) ||
                              userContext.userRoles.includes(
                                "PAEconomicalManager"
                              ) ||
                              userContext.isAdmin) && (
                              <div className="d-flex align-items-center ml-2 pr-3 text-nowrap">
                                <Icon icon="it-info-circle" fill="#06c" />
                                <NavLink
                                  id="auth-invalid-flows"
                                  to="/authModule/invalidFlows"
                                  className="d-flex align-items-center justify-content-between w-100"
                                  onClick={(e) => {
                                    addActiveNavigation(e);
                                  }}
                                >
                                  Flussi non validi{" "}
                                  {
                                    <span className="stagedFlowsNotValidCount notification-count red">
                                      {stagedFlowsNotValidCount}
                                    </span>
                                  }
                                </NavLink>
                              </div>
                            )}
                          {userContext.isAdmin && (
                            <div
                              className="d-flex align-items-center ml-2 pr-3 text-nowrap"
                              onClick={(e) => {
                                addActiveNavigation(e);
                              }}
                            >
                              <Icon icon="it-info-circle" fill="#06c" />
                              <NavLink
                                id="auth-invalid-flows"
                                to="/authModule/flowsWithFailedCostCalculation"
                                className="d-flex align-items-center justify-content-between w-100"
                                onClick={(e) => {
                                  addActiveNavigation(e);
                                }}
                              >
                                Flussi (costo non calcolato)
                                {
                                  <span className="stagedFlowsNotCalculatedCount notification-count red">
                                    {stagedFlowsNotCalculatedCount}
                                  </span>
                                }
                              </NavLink>
                            </div>
                          )}
                          {userContext.userRoles !== null &&
                            (userContext.userRoles.includes(
                              "PASectorManager"
                            ) ||
                              userContext.userRoles.includes(
                                "PAEconomicalManager"
                              ) ||
                              userContext.isAdmin) && (
                              <div className="d-flex align-items-center ml-2 pr-3 text-nowrap">
                                <Icon icon="it-info-circle" fill="#06c" />
                                <NavLink
                                  id="auth-invalid-flows"
                                  to="/authModule/flowsArchive"
                                  className="d-flex align-items-center justify-content-between w-100"
                                  onClick={(e) => addActiveNavigation(e)}
                                >
                                  Flussi archiviati
                                </NavLink>
                              </div>
                            )}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </NavItem>
                  )}
                {userContext.userRoles !== null &&
                  (userContext.userRoles.includes("PAAdmin") ||
                    userContext.isAdmin) && (
                    <NavItem className="mb-4">
                      <NavLink
                        to="/users"
                        onClick={(e) => addActiveNavigation(e)}
                      >
                        Gestione utenze (Ente)
                      </NavLink>
                    </NavItem>
                  )}
              </Nav>
              <div>
                <UncontrolledDropdown className="mt-3 mt-md-0 mb-5">
                  <DropdownToggle className="dropdownToggle">
                    <Icon icon="it-user" fill="#fff" className="user" />
                    <Icon icon="it-expand" fill="#fff" className="downArrow" />
                  </DropdownToggle>
                  <DropdownMenu className="mobile-user-dropdown">
                    <div className="d-flex align-items-center m-2">
                      <span className="user-email">
                        <Icon icon="it-user" />
                      </span>
                      <p className="m-0">{userContext.userEmail}</p>
                    </div>
                    <hr />
                    <div className="d-flex align-items-center ml-2">
                      <Icon icon="it-settings" fill="#06c" />
                      <Link
                        to={null}
                        id="change-password"
                        onClick={(e) => changePasswordHandler(e)}
                        className="text-nowrap"
                      >
                        Cambia Password
                      </Link>
                    </div>
                    {userContext.isAdmin && (
                      <div className="d-flex align-items-center ml-2">
                        <Icon icon="it-pa" fill="#06c" />
                        <Link
                          to={null}
                          id="change-client"
                          onClick={(e) => {
                            setModalOpen(true);
                            setMobileOpen(false);
                            document
                              .querySelector(".it-header-center-wrapper")
                              .classList.remove("max-height");
                          }}
                        >
                          Cambia Ente
                        </Link>
                      </div>
                    )}
                    {userContext.isAdmin && (
                      <div className="d-flex align-items-center ml-2">
                        <Icon icon="it-settings" fill="#06c" />
                        <Link
                          to={null}
                          id="change-client"
                          onClick={(e) => setMunicipalityConfigModalOpen(true)}
                        >
                          Configura Ente
                        </Link>
                      </div>
                    )}
                    {userContext.isAdmin && (
                      <div className="d-flex align-items-center ml-2">
                        <Icon icon="it-pa" fill="#06c" />
                        <Link
                          to="/clientConfiguration"
                          id="configure-client"
                          onClick={(e) => {
                            document
                              .querySelector(".user-dropdown .dropdown-menu")
                              .classList.remove("show");
                            setMobileOpen(false);
                            document
                              .querySelector(".it-header-center-wrapper")
                              .classList.remove("max-height");
                          }}
                        >
                          Configura Modulo AI
                        </Link>
                      </div>
                    )}
                    {userContext.isAdmin && (
                      <div className="d-flex align-items-center ml-2">
                        <Icon icon="it-pa" fill="#06c" />
                        <Link
                          to="/externalFlowConfiguration"
                          id="configure-external-flows"
                          onClick={(e) => {
                            document
                              .querySelector(".user-dropdown .dropdown-menu")
                              .classList.remove("show");
                            setMobileOpen(false);
                            document
                              .querySelector(".it-header-center-wrapper")
                              .classList.remove("max-height");
                          }}
                        >
                          Configura Flussi Esterni
                        </Link>
                      </div>
                    )}
                    {userContext.isAdmin && (
                      <div className="d-flex align-items-center ml-2 text-nowrap mr-2">
                        <Icon icon="it-tool" fill="#06c" />
                        <Link
                          to="/authModuleConfiguration"
                          id="configure-auth-module"
                          onClick={(e) => {
                            document
                              .querySelector(".user-dropdown .dropdown-menu")
                              .classList.remove("show");
                            setMobileOpen(false);
                            document
                              .querySelector(".it-header-center-wrapper")
                              .classList.remove("max-height");
                          }}
                        >
                          Configura Modulo Autorizzativo
                        </Link>
                      </div>
                    )}
                    <div className="d-flex align-items-center ml-2">
                      <Icon icon="it-download" className="logout" fill="#06c" />
                      <Link id="logout" onClick={() => logoutHandler()}>
                        Logout
                      </Link>
                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </div>
          )}
        </HeaderContent>
      </Header>
      {error !== null && error.length !== undefined && (
        <Alert color="danger" className="mx-auto">
          {error.map((item) => (
            <p key={item}>{item}</p>
          ))}
        </Alert>
      )}
      <EmailSentModal
        modalOpen={emailSentModalOpen}
        modalCloseHandler={emailSentModalCloseHandler}
        signOut={signOut}
        message={
          "Una email è stata inviata al tuo indirizzo con il link per modificare la password."
        }
      />
      <MunicipalityConfigurationModal
        modalOpen={municipalityConfigModalOpen}
        modalCloseHandler={municipalityConfigModalCloseHandler}
      />
      <MunicipalityChangeModal
        modalOpen={modalOpen}
        modalCloseHandler={modalCloseHandler}
      />
    </Fragment>
  );
};

export default Navigation;
